import { render, staticRenderFns } from "./NoticeDetailSample.vue?vue&type=template&id=71257c59&scoped=true"
import script from "./NoticeDetailSample.vue?vue&type=script&lang=js"
export * from "./NoticeDetailSample.vue?vue&type=script&lang=js"
import style0 from "./NoticeDetailSample.vue?vue&type=style&index=0&id=71257c59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71257c59",
  null
  
)

export default component.exports